<template>
    <base-page :model="basePageProps">
        <div class="article-page">
            <img v-if="model.image" :src="model.image?.url" :alt="model.image?.text" :title="model.image?.text"
                class="image-cover" />
            <main class="article-content">
                <h1 class="title">{{ model.title }}</h1>
                <p class="date">{{ date }}</p>
                <div v-if="model.description" class="description" v-html="model.description"></div>
                <slot></slot>
                <ShareNetwork :networks="shareNetworks" :shareText="model.translations['article.Share']"
                    class="share-network"></ShareNetwork>
                <div class="tags">
                    <Button v-for="tag in model.tags">{{ tag }}</Button>
                </div>
            </main>
        </div>
    </base-page>
    <related-articles v-if="model.relatedArticles?.length" :related-articles="model.relatedArticles"
        :translations="model.translations"></related-articles>
</template>
<script lang="ts" setup>
import { IHeroSection } from '@/models/model';
import { IArticleProps } from './Article.model';
import BasePage from '@/components/Common/BasePage/BasePage.vue';
import { computed } from 'vue';
import { longLocalDate } from '@/share/util';
import ShareNetwork from '@/components/Common/ShareNetwork/ShareNetwork.vue';
import { INetwork } from '@/components/Common/ShareNetwork/ShareNetwork.model';
import { siFacebook } from 'simple-icons/icons'
import { siX } from 'simple-icons/icons'
import linkedinSvg from '@/assets/linkedInLogo.svg?raw'
import { Button } from '@/components/ui/button';
import RelatedArticles from '../RelatedArticles/RelatedArticles.vue';

const { model } = defineProps<IArticleProps>();

const date = computed(() => longLocalDate(window.__STATE__?.culture ?? "", model.date))

const basePageProps = computed<IHeroSection>(() => ({
    title: model.title,
    subtitle: date.value
}))
const shareNetworks: INetwork[] = [{
    name: "facebook",
    icon: siFacebook.svg,
    network: "facebook",
    url: window.location.href,
    media: model.image?.url,
    color: "var(--primary)"
}, {
    name: "x",
    icon: siX.svg,
    network: "x",
    url: window.location.href,
    media: model.image?.url,
    color: "var(--primary)"
}, {
    name: "linkedin",
    icon: linkedinSvg,
    network: "linkedin",
    url: window.location.href,
    media: model.image?.url,
    color: "var(--primary)"
}]

const borderRadius = model.relatedArticles?.length ? 'unset' : '0 0 24px 24px';
const borderBottom = model.relatedArticles?.length ? 'none' : '1px solid lightgray';
</script>
<style lang="scss" scoped>
.image-cover {
    width: 100%;
}

.article-page {
    border: 1px solid lightgray;
    border-top: 0;
    border-radius: v-bind(borderRadius);
    border-bottom: v-bind(borderBottom);
}

.article-content {
    padding: 24px 30px;
}

.title {
    font-weight: 700;
    font-size: 2.0625rem;
    line-height: 3rem;
}

.date {
    font-weight: 300;
    font-size: .8125rem;
    color: #969696;
    margin-bottom: 15px;
}

.description {
    margin-bottom: 20px;
    line-height: 1.6;
}

.share-network {
    margin-top: 20px;
    display: flex;
    justify-content: center;

    :deep(.icon svg) {
        transition: fill 0.3s ease-in-out;

        &:hover {
            fill: var(--primary-dark);
        }
    }
}

.tags {
    margin-top: 10px;
    display: flex;
    gap: 5px;
    justify-content: center;
    flex-wrap: wrap;
}
</style>